package pwgs.ui.scenes.analyticsdashboardscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(AnalyticsDashboardSceneProps::class, AnalyticsDashboardSceneModel::class)
interface AnalyticsDashboard {
    fun load()
    fun refreshRealtimeStats()
}

@Serializable
class AnalyticsDashboardSceneProps(val projectId: Long)

@Serializable
class AnalyticsDashboardSceneModel(
    var realtimeStats: AnalyticsDashboardRealtimeStatsModel,
    val last30DayStats: List<StatItemModel>,
)

@Serializable
class AnalyticsDashboardRealtimeStatsModel(
    val onlineUsersCount: Int,
    val newUsersCount: Int,
    val returningUsersCount: Int,
    val sessionsCount: Int
)


@Serializable
class StatItemModel(
    val date: String,
    val newUsersCount: Long,
    val returningUsersCount: Long,
    val sessionsCount: Long,
)